import type { FieldConfig } from '@/mocks/questionnaire';
import { inputClass } from '@/pages/home/components/fields/styles';

interface TextFieldProps {
  field: FieldConfig;
  value: string;
  onChange: (value: string) => void;
}

export default function TextField({ field, value, onChange }: TextFieldProps) {
  return (
    <div>
      <label
        htmlFor={field.name}
        className="block text-sm font-semibold text-foreground-900 mb-2"
      >
        {field.label}
        {field.hint ? (
          <span className="text-xs font-normal text-foreground-400 ml-1">{field.hint}</span>
        ) : null}
      </label>
      <input
        id={field.name}
        name={field.name}
        type={field.name === 'contact' ? 'tel' : 'text'}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={field.placeholder}
        autoComplete="off"
        className={inputClass}
      />
    </div>
  );
}